/**
 * @license
 * Copyright Mauricio Gemelli Vigolo All Rights Reserved.
 *
 * Use of this source code is governed by a MIT-style license that can be
 * found in the LICENSE file at https://github.com/mauriciovigolo/keycloak-angular/blob/main/LICENSE.md
 */

// This legacy implementation will be removed in Keycloak Angular v20
export { KeycloakEventLegacy, KeycloakEventTypeLegacy } from './core/interfaces/keycloak-event';
export { KeycloakOptions } from './core/interfaces/keycloak-options';
export { KeycloakAuthGuard } from './core/services/keycloak-auth-guard';
export { KeycloakService } from './core/services/keycloak.service';
export { KeycloakBearerInterceptor } from './core/interceptors/keycloak-bearer.interceptor';
export { CoreModule } from './core/core.module';
export { KeycloakAngularModule } from './keycloak-angular.module';
